import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button, Calendar } from "../ui";
import { CalendarIcon, CircleX } from "lucide-react";
import { useState } from "react";

const DateRangePicker = ({
  value,
  onChange,
  disabled,
  maxDate,
  minDate,
  onClear,
}: {
  value: { from: Date | undefined; to: Date | undefined };
  onChange: (range: { from: Date | undefined; to: Date | undefined }) => void;
  disabled?: boolean;
  maxDate?: any;
  minDate?: any;
  onClear?: any;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <Button
          variant="outline"
          className={cn(
            "w-full items-center justify-between text-left font-normal h-[40px] text-sidebar-foreground group relative",
            !value.from && !value.to && "text-muted-foreground"
          )}
          disabled={disabled}
        >
          {value.from && value.to ? (
            <>
              {format(value.from, "LLL dd, yyyy")} -{" "}
              {format(value.to, "LLL dd, yyyy")}
            </>
          ) : (
            <span>Pick a date range</span>
          )}
          {value.from && value.to ? (
            <div
              className="h-5 w-5 cursor-pointer flex items-center justify-end"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation(); // Prevents triggering the button click
                onClear && onClear();
                onChange({ from: undefined, to: undefined });
              }}
            >
              <CircleX className="stroke-gray-500 group-hover:stroke-black" />
            </div>
          ) : (
            <CalendarIcon className="mr-2 h-4 w-4" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="range"
          selected={value}
          onSelect={(range) => {
            onChange(range as { from: Date | undefined; to: Date | undefined });
          }}
          numberOfMonths={2}
          disabled={(day) => day < minDate || day > maxDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DateRangePicker;
